import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';

const SubcompanyActions = ({
  canEdit,
  canToggle,
  companyId,
  handleToggle,
  isLoading,
  subcompany,
  t,
}) =>
  canEdit || canToggle ? (
    <div className="text-right mt-4">
      {canToggle && (
        <Form.Button
          color={subcompany.active ? 'secondary' : 'secondary'}
          extraClassName="btn-sm mr-2"
          isLoading={isLoading}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleToggle(subcompany.id);
          }}
          text={t(subcompany.active ? 'actions.deactivate' : 'actions.activate')}
          type={'button'}
        />
      )}
      {canEdit && subcompany.active && (
        <Form.Link
          to={`/companies/${companyId}/subcompanies/${subcompany.id}/edit`}
          className={classnames('btn btn-primary btn-sm', {
            disabled: isLoading,
          })}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {t('actions.edit')}
        </Form.Link>
      )}
    </div>
  ) : null;

SubcompanyActions.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  canToggle: PropTypes.bool.isRequired,
  companyId: PropTypes.string.isRequired,
  handleToggle: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  subcompany: PropTypes.object.isRequired,
};

export default translate()(SubcompanyActions);



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/components/SubcompanyActions.js